function addLayoutLayers(map) {
  for (let i = 0; i < 10; i += 1) {
    map.addLayer({
      id: `z-index-${i + 1}`,
      type: 'line',
      source: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [],
        },
      },
      layout: {
        visibility: 'none',
      },
    });
  }
}

function removeLayerAndSource(map, layerId, sourceId = undefined) {
  if (map._removed) return;

  if (map.getLayer(layerId)) {
    map.removeLayer(layerId);
  }

  if (sourceId && map.getSource(sourceId)) {
    map.removeSource(sourceId);
  }
}

export {
  addLayoutLayers,
  removeLayerAndSource,
};
